var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ff8a00;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-construction-stop"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 3.62,
    width: 18,
    height: 10.04,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5,
    y1: 13.66,
    x2: 8.89,
    y2: 3.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.41,
    y1: 13.66,
    x2: 14.72,
    y2: 3.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.67,
    y1: 13.66,
    x2: 19.59,
    y2: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.12,13.66V19a1.51,1.51,0,0,1-1.61,1.4h0A1.51,1.51,0,0,1,5.91,19V13.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.58,13.66V19A1.51,1.51,0,0,1,16,20.38h0a1.51,1.51,0,0,1-1.6-1.4V13.66"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.f0020fb649fda564d0762a8f69c49ab6.svg";
export { ForwardRef as ReactComponent };